import { axiosBackEndInstance } from '../Axios';
import { END_POINT_BRANCH } from '../Axios/ENDPOINTS';
import { notification } from 'antd';
import { useErrorHandling } from '../hooks/useErrorHandling';
import { useGetUsers } from './useGetUsers';
import { useGetBranch } from './useGetBranch';


export const useBranch= () => {

    const {errorHandling} = useErrorHandling()
    const { mutate } = useGetBranch()
     
     const createBranch = async (
      callback: Function,
      values:{
        name: string,
        address: string,
        city: string
      }
      
      ): Promise<any> => {      
    try {
      const  data = await axiosBackEndInstance.post(
        END_POINT_BRANCH, values
      )
      const status =  errorHandling(data).request.status
      if(status === 200){
        callback()
        mutate()
        notification.success({
          message: 'Éxito', 
          description:'Sucursal creada con éxito', 
          placement: 'topRight'
      })
      }
    } catch (newError) {
      console.log(newError);
      callback()
      
    }
  };

  const editBranch = async (
    callback: Function,
    id: number,
    values:{
      name: string,
      address: string,
      city: string
    }
                            
  ): Promise<void> => {
              
    try {
      const data  = await axiosBackEndInstance.put(
        `${END_POINT_BRANCH}${id}`, values
      );
      callback()   
      if(data.status === 200 || data.status === 201){
        mutate()
        notification.success({
          message: 'Éxito', 
          description:'sucursal editada con éxito', 
          placement: 'topRight'
        })
      }    
    } catch (newError) {    
      callback()
      let status = errorHandling(newError).request.status
      console.log('Status ' + status);
      console.log(newError);
    }
  };

  const deleteBranch = async (
    callback: Function,
    id: number                            
  ): Promise<void> => {
      
    try {
      const data  = await axiosBackEndInstance.delete(
        `${END_POINT_BRANCH}${id}`, 
      );
      callback()   
      if(data.status === 200){
        mutate()
        notification.success({
          message: 'Éxito', 
          description:'sucursal eliminada con éxito', 
          placement: 'topRight'
        })
      }    
    } catch (newError) {
      console.log(newError);
      callback()
      let status = errorHandling(newError).request.status
    }
  };

  return {
    editBranch,
    createBranch,
    deleteBranch
  };
};
